import { isNull } from 'lodash'
import { isObjectNotUndefinedHasProps } from '~/ZenOne-StoryBook/helpers/object'

export const PATTERSON_DENTAL = 'Patterson Dental'
export const PATTERSON_DENTAL_ALIAS = 'pattersondental'

export const getDistributorShippingTermsDescr = (
  distr = {},
  currencyFilter = null
) => {
  if (!isObjectNotUndefinedHasProps(distr) || isNull(currencyFilter)) return ''
  let res = ''
  const {
    shippingCost = 0,
    hasFreeShipping: isFreeShippingActivated = false,
    minFreeShipping = 0,
    hasHandling = false,
    handlingFuelCharge = 0,
  } = distr
  const hazardCost = distr?.hazardCost ? parseInt(distr.hazardCost) : 0
  const overnightCost = distr?.overnightCost ? parseInt(distr.overnightCost) : 0
  const isFreeShipping = distr?.isCoveredByZen || shippingCost === 0
  if (isFreeShipping) res = 'Shipping is Free.'
  else if (shippingCost > 0)
    res = `Shipping fee is ${currencyFilter(shippingCost)}${
      !isFreeShippingActivated ? '.' : ' '
    }`
  if (!isFreeShipping && isFreeShippingActivated && minFreeShipping > 0) {
    res += `with a Free Shipping for orders over ${currencyFilter(
      minFreeShipping
    )}/order.`
  }
  if (hasHandling && handlingFuelCharge > 0) {
    res += ` There is additional Handling/Fuel Surcharge of ${currencyFilter(
      handlingFuelCharge
    )}${
      hazardCost === 0
        ? '.'
        : ` and a Hazard Delivery Fee of ${currencyFilter(hazardCost)}.`
    }`
  } else if (hazardCost > 0)
    res += ` There is additional Hazard Delivery Fee of ${currencyFilter(
      hazardCost
    )}.`
  if (distr?.hasOvernight && overnightCost > 0) {
    res += ` You can get your order overnight for additional ${currencyFilter(
      overnightCost
    )} per order`
  }
  return res
}
